import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import 'moment/locale/ru';
import { formViewProps, formName, } from '../gant.const'
import { daysUntilSunday, diffDays, formDateSelector, parseLocalDate, todayString } from '../utils/dateHelpers';

export default function GridGantt({ heightSVG, zoom, sizeDay, sizeWeek, sizeMonth, yPadding, heightDateLine }) {
  const start = useSelector(formDateSelector(formName, 'start')) || todayString();
  const end = useSelector(formDateSelector(formName, 'end')) || todayString()
  const [countDay, setCountDay] = useState(10)
  const [daysToWeekend, setDaysToWeekend] = useState(0)
  const startDiag = useSelector(formSelector(formViewProps, 'startDiag')) || 1810
  useEffect(() => {
    setCountDay(diffDays(start, end) + 10)
    const startWeekend = moment(start)
    startWeekend.day(7)
    setDaysToWeekend(daysUntilSunday(start) - 1)
  }, [start, end])
  let gridComponent = null
  switch (zoom) {
    case 'day': {
      gridComponent = <GridTableZoomDay
        heightSVG={heightSVG}
        countDay={countDay}
        daysToWeekend={daysToWeekend}
        size={sizeDay}
      />
      break;
    }
    case 'week': {
      gridComponent = <GridTableZoomWeek
        heightSVG={heightSVG}
        countDay={countDay}
        size={sizeWeek}
      />
      break;
    }
    case 'month': {
      gridComponent = <GridTableZoomMonth
        heightSVG={heightSVG}
        countDay={countDay}
        start={start}
        end={end}
        size={sizeMonth}
        yPadding={yPadding}
      />
      break;
    }
    default: {
      gridComponent = null;
      break;
    }
  }
  return <g id="grid-gant" transform={`translate(${startDiag},${heightDateLine})`}>
    {gridComponent}
  </g>
}
function GridTableZoomMonth({ heightSVG, countDay, start, end, size, yPadding }) {
  let offset = 0
  const sizeD = size * 12 / 365
  const [yearArr, setYearArr] = useState([])
  useEffect(() => {
    const startDate = parseLocalDate(start);
    const endDate = parseLocalDate(end);
    if (!startDate || !endDate) {
      setYearArr([]);
      return;
    }
    const res2 = {};
    const cursor = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    while (cursor <= endDate) {
      const year = cursor.getFullYear();
      const month = cursor.getMonth();

      const monthStart = new Date(year, month, 1);
      const monthEnd = new Date(year, month + 1, 0); // последний день

      const rangeStart = monthStart < startDate ? startDate : monthStart;
      const rangeEnd = monthEnd > endDate ? endDate : monthEnd;

      const days = Math.round((rangeEnd - rangeStart) / (1000 * 60 * 60 * 24)) + 1;

      res2[year] = res2[year] || {};
      res2[year][month] = (res2[year][month] ?? 0) + days;

      cursor.setMonth(cursor.getMonth() + 1);
    }

    setYearArr(
      Object.keys(res2).map(year => {
        const arr = new Array(12).fill(0);
        Object.entries(res2[year]).forEach(([m, count]) => {
          arr[m] = count;
        });
        return arr.filter(Number);
      })
    );
  }, [start, end]);
  return <g id="gridMonth">
    {yearArr.map(year => {
      const sizeYear = year.reduce((a, b) => (a + b))
      offset += sizeD * sizeYear
      let offsetMonth = 0
      return <g key={year} transform={`translate(${offset - sizeD * sizeYear})`}>
        {year.map((m, i) => {
          const sizeMonth = m * sizeD
          offsetMonth += sizeMonth
          return <line
            key={year + '_' + i}
            x1={offsetMonth - sizeMonth}
            y1={0}
            x2={offsetMonth - sizeMonth}
            y2={heightSVG}
            stroke="#e0e0e0"
          />
        })}
      </g>
    })}
    <rect
      x={0}
      y={0}
      fill="url(#patternGridYear)"
      fillOpacity={1}
      width={sizeD * countDay}
      height={heightSVG}
      transform={`translate(0,${- yPadding / 2})`}
      stroke='none'
    />
  </g>
}
function GridTableZoomWeek({ heightSVG, countDay, size }) {
  return <rect
    x={0}
    y={0}
    fill="url(#patternGridWeek)"
    fillOpacity={0.1}
    width={size * countDay / 7}
    height={heightSVG}
    transform={`translate(${-size / 14},${-size / 14})`}
    stroke='none'
  />
}
function GridTableZoomDay({ heightSVG, countDay, daysToWeekend, size }) {
  return <g>
    <rect
      x={0}
      y={0}
      fill="url(#patternGridDay)"
      fillOpacity={0.5}
      width={size * countDay}
      height={heightSVG}
      transform={`translate(${-size / 2},${-size / 2})`}
      stroke='none'
    />
    <rect
      x={0}
      y={0}
      fill="url(#patternGridWeekend)"
      fillOpacity={0.1}
      width={size * countDay}
      height={heightSVG}
      transform={`translate(${size * daysToWeekend},0)`}
      stroke='none'
    />
  </g>
}
function formSelector(formName, field) {
  return state => state.form?.[formName]?.values[field]
}